import React, { useState, useRef } from "react";
import styles from "./PopupForm.module.scss";
import { usePopupForm } from "@/context/PopupFormContext"; // Хук для контексту попапа

const PopupForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const popupRef = useRef<HTMLDivElement>(null);

  const { isOpenForm, closeForm } = usePopupForm(); // Використовуємо функцію для закриття форми з контексту

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);

    const { name, email, phone, message } = formData;

    const formPayload = {
      type: "feedback",
      legid: 1,
      data: {
        name: name,
        phone: phone,
        email: email,
        message: message,
      },
    };

    try {
      await sendToCRM(formPayload); // Відправка тільки до CRM

      alert("Ihre Nachricht wurde erfolgreich gesendet!"); // Успішний алерт

      window.dataLayer.push({
        event: "form_submit", // Назва події
        form_name: "career_form", // Назва вашої форми
        form_type: "feedbackcareer", // Можна передати тип форми
      });

      setFormData({ name: "", email: "", phone: "", message: "" });
      closeForm(); // Закриваємо попап після успішної відправки
    } catch (error) {
      alert("Etwas ist schief gelaufen. Versuchen Sie es später erneut."); // Алерт про помилку
    } finally {
      setLoading(false);
    }
  };

  const sendToCRM = async (data: any) => {
    try {
      const res = await fetch("https://crm.hixa.eu/external/goodsapi/", {
        method: "POST",
        headers: {
          Authorization: `Bearer DH345DFGDGb32FDsf03876SDFSdf13`,
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        body: new URLSearchParams({
          type: data.type,
          legid: data.legid.toString(),
          ...Object.entries(data.data).reduce((acc, [key, value]) => {
            acc[key] = value as string;
            return acc;
          }, {} as Record<string, string>),
        }),
      });

      if (!res.ok) {
        throw new Error(`Failed to send message to CRM: ${res.statusText}`);
      }

      return await res.json(); // Повертаємо відповідь від сервера
    } catch (error) {
      throw error; // Якщо є помилка, передаємо її далі
    }
  };

  return (
    <>
      {isOpenForm && (
        <div className={styles.popWrapper}>
          <div className="container">
            <div className={styles.popupForm} ref={popupRef}>
              <button className={styles.closePopup} onClick={closeForm}>
                <svg
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <div className={styles.popupFormTitle}>
                <h3>Hinterlassen Sie Ihre Anfrage</h3>
              </div>

              <form className={styles.form} onSubmit={handleSubmit}>
                <div className={styles.formLine}>
                  <input
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Name"
                  />
                </div>

                <div className={styles.formLine}>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Telefonnummer"
                  />
                </div>

                <div className={styles.formLine}>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="E-Mail"
                  />
                </div>

                <div className={styles.formLine}>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Ihre Nachricht an uns"
                  />
                </div>

                <button
                  type="submit"
                  className={`${styles.submitBtn} commonButton buttonLg`} // Об'єднуємо локальний клас з глобальним
                  disabled={loading}
                >
                  {loading ? "Senden..." : "Senden"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PopupForm;
